var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatBack"},[_c('img',{staticClass:"chatLogo",attrs:{"src":"https://delicity.b-cdn.net/front/img/logoquare.png"}}),_c('img',{staticClass:"chatBack_text animate__animated animate__bounceIn",attrs:{"src":"/img/support.png"}})])
}]

export { render, staticRenderFns }